import { render } from "./RemoveVariable.vue?vue&type=template&id=716da9cd&scoped=true&ts=true"
import script from "./RemoveVariable.vue?vue&type=script&lang=ts"
export * from "./RemoveVariable.vue?vue&type=script&lang=ts"

import "./RemoveVariable.vue?vue&type=style&index=0&id=716da9cd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716da9cd"]])

export default __exports__